/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React, { useState, useEffect } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import LazyLoad from 'react-lazyload';
import {
  getSponsorData,
  getItemId,
  createDestinationUrl,
  getLoggedInStatus,
  showCBS,
} from '../../../utils/utils';
import ImgCrop from '../../Common/ImgCrop';
import { CONTENT_TYPE } from '../../../constants/globalConstants';
import Sponsor from '../../Common/Sponsor';
import * as track from '../../../utils/analytics';
import { useSponsorValue } from '../../../context/sponsorContext';
import { useModal } from '../../Common/Modal';
import ErrorBoundary from '../../Common/ErrorBoundary';
import Loader from '../../Common/Loader';
import loadable from '@loadable/component';
import MU from '../../../constants/muConstants';
import CalendarModal from '../../Modals/CalendarModal';
import {
  AddToCalendarButtons,
  appleShortAddtoCalendar,
  calendarHeadline,
  fixtureCalendarHeadline,
  getFixtureConfiguration,
  getFixtureTeam,
  googleShortAddtoCalendar,
  noteDescription,
  noteHeadline,
  outlookShortAddtoCalendar,
} from '../../../utils/reminderUtils';
const RegistrationModal = loadable(() =>
  import('../../Modals/RegistrationModal/RegistrationModal')
);

const Teamlevelcalendar = (props) => {
  const { fields, gridClass, isMatchcenterCard, container } = props;
  const {
    Image,
    Headline,
    Theme,
    ContentAccess,
    CTATitle,
    CTAUrl,
    ContentType,
    Sponsorby,
    manutds,
  } = fields;
  const [{ isUserLogin, isLoginChecked, isUserSubscribe, isUserSkyId }] = useSponsorValue();
  const contentAccessState = ContentAccess && ContentAccess.value;
  const { showModal, closeModal, isModalVisible } = useModal();
  const {
    showModal: cbrShowModal,
    closeModal: cbrCloseModal,
    isModalVisible: cbrModalVisible,
  } = useModal();
  const [successScrollState, setSuccessScrollState] = useState({
    x: '',
    y: '',
  });

  const itemId = getItemId(props);

  const sponsorInfo = Sponsorby && getSponsorData(Sponsorby.fields);
  const enableCalendar = MU?.eventCalendar?.enableCalendar;

  const forCalendarGetTeam = () => {
    const Tags = manutds?.value?.Tags['Team Level'][0]?.Tag;
    if (Tags && Tags.includes('/')) {
      return Tags.split('/')[1];
    }
  };
  const fixtureTeamName = () => {
    const getTeam = forCalendarGetTeam();
    if (getTeam) {
      return getFixtureTeam(getTeam);
    } else return '';
  };
  const configData = () => {
    const selectedTeam = forCalendarGetTeam();
    const getTeamData = getFixtureConfiguration(selectedTeam);
    if (getTeamData) {
      return getTeamData;
    } else return '';
  };

  const getAnalyticsData = (fields) => {
    const initialData = track.data('card');
    return {
      ...initialData,
      card_name: Headline && Headline.value,
      container_type: container,
      item_id: itemId,
      content_type: ContentType && ContentType.value,
      tag: manutds && manutds.value && manutds.value.Tags,
      created_datetime: fields.__Published && fields.__Published.value,
      author: fields.Author && fields.Author.value,
      destination_url: CTAUrl && CTAUrl.value && CTAUrl.value.href,
      w_theme: Theme && Theme.value,
      w_item_name: manutds && manutds.value && manutds.value.__Name,
      subscription_status: getLoggedInStatus({
        isLoginChecked,
        isUserLogin,
        isUserSubscribe,
        isUserSkyId,
      }),
      content_status: contentAccessState,
    };
  };

  const successCallback = ({ showContent, isSubscribedContent }) => {
    if (showContent) {
      const destinationUrl = createDestinationUrl(CTAUrl && CTAUrl.value && CTAUrl.value.href);
      if (!MU.isIDMEnabled) window.location.href = destinationUrl;
      else {
        return ['successCallbck', isSubscribedContent, 'calendarModal', forCalendarGetTeam()];
      }
    }
  };

  const onCardClick = (e) => {
    e.preventDefault();
    if (showCBS({ isUserLogin, isUserSubscribe, contentAccessState })) {
      cbrShowModal();
    } else {
      showModal();
    }
    trackLink(e);
  };

  const trackLink = (e) => {
    const initialData = track.data('link');
    track.analytics(
      {
        ...initialData,
        button_name: Headline && Headline.value,
        destination_url: CTAUrl && CTAUrl.value && CTAUrl.value.href,
      },
      e
    );
  };
  const getTheme = function (themeName) {
    let themeClass;
    if (themeName != undefined && themeName != 'undefined') {
      themeClass = themeName.toLowerCase() === 'stroke' ? 'ad-stroke' : '';
    }
    return themeClass;
  };

  return (
    <React.Fragment>
      <div className={`${gridClass} ${isMatchcenterCard ? 'ratio-matchday' : 'ratio'}`}>
        <div className="mu-content">
          <div
            className={`teamLevelCalendar-card mu-item ${
              Theme && Theme.value && getTheme(Theme.value)
            }`}
          >
            <div tabIndex="-1" className="img-holder">
              {Image && Image.value && Image.value.Crops && (
                <LazyLoad once={true} offset={100}>
                  <ImgCrop
                    imgCrop={Image.value.Crops}
                    alt={Image.value.AltText}
                    title={Image.value.AltText}
                    isWebpAvailable={Image.value.isWebpAvailable}
                    singleSrc={false}
                    gridClass={gridClass}
                  ></ImgCrop>
                </LazyLoad>
              )}
            </div>
            <div className="mu-item__info">
              <Sponsor
                contentType={ContentType && ContentType.value}
                varient=""
                sponsorInfo={sponsorInfo}
                grid={gridClass}
                type={CONTENT_TYPE}
                author={fields.Author && fields.Author.value}
                cardName={Headline && Headline.value}
                container={container}
                createdDateTime={fields.__Published && fields.__Published.value}
                itemId={itemId}
                tags={manutds && manutds.value && manutds.value.Tags}
                isAdCard={true}
              ></Sponsor>

              {Headline && Headline.value && (
                <h2 className="mu-item__title">
                  <Text field={Headline} />
                  <span className="screenreader">&nbsp;{ContentType && ContentType.value}</span>
                </h2>
              )}
              {CTATitle && CTATitle.value && (
                <div className="red-btn-skew">
                  <a
                    href="#"
                    onClick={(e) => {
                      onCardClick(e);
                    }}
                  >
                    <span>
                      <Text field={CTATitle} />
                    </span>
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {cbrModalVisible && (
        <ErrorBoundary>
          <RegistrationModal
            successCallback={successCallback}
            closeModal={cbrCloseModal}
            fallback={<Loader />}
            previousActiveElement={document.activeElement}
            accessType={contentAccessState}
            analyticsObj={getAnalyticsData(fields)}
          />
        </ErrorBoundary>
      )}
      <ErrorBoundary>
        {isModalVisible && enableCalendar && (
          <CalendarModal
            fallback={<Loader />}
            AddToCalendarButtons={AddToCalendarButtons}
            closeModal={closeModal}
            calendarTitle={fixtureTeamName()}
            fixtureCalendarHeadline={fixtureCalendarHeadline()}
            calendarHeadline={calendarHeadline()}
            noteHeadline={noteHeadline()}
            noteDescription={noteDescription()}
            appleShortAddtoCalendar={appleShortAddtoCalendar()}
            googleShortAddtoCalendar={googleShortAddtoCalendar()}
            outlookShortAddtoCalendar={outlookShortAddtoCalendar()}
            configData={configData()}
            isFixtureCard={true}
          ></CalendarModal>
        )}
      </ErrorBoundary>
    </React.Fragment>
  );
};
export default Teamlevelcalendar;
